var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPermission(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11249_4474)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.2903 2.12601L13.0313 0.0510113C12.8272 -0.0170038 12.6065 -0.0170038 12.4023 0.0510113L6.14331 2.12601C5.14524 2.45568 4.27666 3.09192 3.66132 3.9441C3.04598 4.79627 2.71527 5.8209 2.71631 6.87201V12.043C2.71631 18.606 9.72131 22.62 11.8683 23.693C11.8683 23.693 12.3353 24 12.7183 24C13.1013 24 13.5093 23.76 13.5093 23.76C15.6693 22.891 22.7163 19.479 22.7163 12.043V6.87201C22.7174 5.8209 22.3866 4.79627 21.7713 3.9441C21.156 3.09192 20.2884 2.45568 19.2903 2.12601ZM13.7173 11.791V15C13.7173 15.2652 13.612 15.5196 13.4244 15.7071C13.2369 15.8947 12.9825 16 12.7173 16C12.4521 16 12.1977 15.8947 12.0102 15.7071C11.8227 15.5196 11.7173 15.2652 11.7173 15V11.791C11.1909 11.5613 10.7597 11.1573 10.4961 10.647C10.2325 10.1367 10.1527 9.55119 10.27 8.98895C10.3874 8.42671 10.6947 7.92203 11.1404 7.55976C11.5861 7.19749 12.143 6.99972 12.7173 6.99972C13.2917 6.99972 13.8485 7.19749 14.2942 7.55976C14.7399 7.92203 15.0472 8.42671 15.1646 8.98895C15.2819 9.55119 15.2021 10.1367 14.9385 10.647C14.675 11.1573 14.2437 11.5613 13.7173 11.791Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11249_4474"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.717285)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPermission);
export default __webpack_public_path__ + "static/media/permission.2766f86ac6e1ff005e637142154717ba.svg";
export { ForwardRef as ReactComponent };